export const FLAG_GETTING_DELIVERY_GROUPS = 'FLAG_GETTING_DELIVERY_GROUPS';
export const GET_DELIVERY_GROUPS = 'GET_DELIVERY_GROUPS';
export const CLEAR_DELIVERY_GROUPS = 'CLEAR_DELIVERY_GROUPS';
export const FLAG_DELIVERY_GROUP_ACTIVITY = 'FLAG_DELIVERY_GROUP_ACTIVITY';
export const GET_DELIVERY_GROUP = 'GET_DELIVERY_GROUP';
export const CLEAR_DELIVERY_GROUP = 'CLEAR_DELIVERY_GROUP';
